import React from 'react';
import { useNavigate } from 'react-router-dom';
import image from '../assest/logo/logo.jpg'; 

const ErrorPage = ({ errorCode = 404, errorMessage = "الصفحة غير موجودة" }) => {
    const navigate = useNavigate();

    return (
        <div style={styles.body}>
            <div style={styles.errorContainer}>
                <img 
                    loading='lazy'
                    src={image}
                    alt="شركة خطوة المستثمر"
                    style={styles.logo}
                />
                
                <h1 style={styles.heading}>حدث خطأ ما! ⚠️</h1>
                
                <div style={styles.errorCode}>
                    {errorCode}
                </div>

                <p style={styles.subHeading}>
                    {errorMessage}
                </p>

                <p style={styles.message}>
                    عذراً، لا يمكن الوصول إلى الصفحة المطلوبة حاليًا. يرجى مراجعة الرابط أو العودة للصفحة الرئيسية.
                </p>

                <button
                    onClick={() => navigate('/')}
                    style={styles.button}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
                >
                    العودة إلى الصفحة الرئيسية
                </button>

                <div style={styles.contact}>
                    <p>
                        إذا استمرت المشكلة، يرجى التواصل معنا:
                    </p>
                    <div style={styles.contactLinks}>
                        <a href="mailto:info@investor-step.com" style={styles.link}>البريد الإلكتروني</a>
                        <span style={styles.separator}>|</span>
                        <a href="tel:+966547382666" style={styles.link}>0547382666</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    body: {
        fontFamily: 'Cairo, Tajawal, sans-serif',
        color: '#333',
        margin: 0,
        padding: 0,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F7F7F7', 
    },
    errorContainer: {
        maxWidth: '500px',
        padding: '40px',
        backgroundColor: '#fff',
        borderRadius: '15px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
        width: '100%',
        transition: 'all 0.3s ease',
        border: '1px solid #eee',
    },
    logo: {
        width: '100px',
        marginBottom: '25px',
    },
    heading: {
        color: '#BD9D67', // لون العلامة التجارية الفاتح (الذهبي)
        fontSize: '48px',
        marginBottom: '5px',
        fontWeight: '700',
    },
    errorCode: {
        color: '#57482F', // لون العلامة التجارية الداكن
        fontSize: '70px',
        fontWeight: '900',
        lineHeight: '1',
        margin: '0 0 10px 0',
    },
    subHeading: {
        fontSize: '22px',
        color: '#57482F',
        fontWeight: '600',
        marginBottom: '25px',
        borderBottom: '2px solid #eee',
        paddingBottom: '15px',
    },
    message: {
        fontSize: '16px',
        lineHeight: '1.7',
        color: '#666',
        marginBottom: '35px',
    },
    button: {
        fontFamily:"Cairo",
        display: 'inline-block',
        padding: '14px 35px',
        backgroundColor: '#57482F',
        color: 'white',
        borderRadius: '50px',
        fontWeight: 'bold',
        transition: 'background-color 0.3s, transform 0.1s',
        border: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        margin: '20px 0',
        boxShadow: '0 5px 15px rgba(87, 72, 47, 0.3)',
    },
    buttonHover: {
        backgroundColor: '#BD9D67', // تغيير اللون عند التحويم لزيادة التفاعل
    },
    contact: {
        marginTop: '30px',
        paddingTop: '20px',
        borderTop: '1px solid #f0f0f0',
        fontSize: '15px',
        color: '#888',
    },
    contactLinks: {
        marginTop: '10px',
        display: 'flex',
        justifyContent: 'center',
        gap: '15px',
        fontSize: '16px',
    },
    link: {
        color: '#BD9D67',
        fontWeight: 'bold',
        textDecoration: 'none',
        transition: 'color 0.3s',
    },
    separator: {
        color: '#ccc',
    }
};

export default ErrorPage;